import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import tables_template from '~/templates/tra-tables.handlebars';
import GeneralView from '~/generalView';
import toastr from 'toastr';

var traTablesView = GeneralView.View.extend({
    tagName: "div",
    className: '',
    trazobj: '',
    kind: '',
    kind2: '',
    trazreport: '',
    changeorderbtntext: 'Ver Orden Descendente',
    events: {
        'click #createexcel':'createexcel',
        'click #tableschangeorder' : 'orderarray',
    },

    render: function () {
      this.attachEvents();
      return this;
    },

    orderarray: function(){
        this.trazobj.models = [].concat(this.trazobj.models).reverse();
        var handlebarsTemplate = Handlebars.template(tables_template);
        this.$el.html(handlebarsTemplate(this.trazobj));
		$('.tratableloader').hide();
        this.settittle(this.kind,this.trazreport);
        if (this.changeorderbtntext == "Ver Orden Descendente") {
            this.changeorderbtntext = "Ver Orden Ascendente"; 
            $("#tableschangeorder").text(this.changeorderbtntext);
        }else{
            this.changeorderbtntext = "Ver Orden Descendente"; 
            $("#tableschangeorder").text(this.changeorderbtntext);
        }
    },
	
	settittle: function(kind,trazreport){
        if (kind == 'report') {
            this.kind2 = 'Reporte';
            this.id = trazreport.report[0].id;
            $(".tablestittle").text("Tabla para reporte: "+ trazreport.report[0].id);
            $(".linktotimeline").attr("href", "#timeline?kind=report&id="+trazreport.report[0].id);
        }
        if (kind == 'user') {
            this.kind2 = 'Usuario';
            this.id = trazreport.user[0].attributes.username;
            $(".tablestittle").text("Tabla para usuario: "+ trazreport.user[0].attributes.username); 
            $(".linktotimeline").attr("href", "#timeline?kind=user&id="+trazreport.user[0].id+"&username="+trazreport.user[0].attributes.username);
        }
    },
	
    showtable: function(trazreport,kind){
		var arrayobj = this.settraz(trazreport,kind);
		this.trazobj = arrayobj;
		this.kind = kind; 
		this.trazreport = trazreport;
		var handlebarsTemplate = Handlebars.template(tables_template);
		this.$el.html(handlebarsTemplate(arrayobj));
		$('.tratableloader').hide();
		this.settittle(kind, trazreport);
		$("#tableschangeorder").text(this.changeorderbtntext);
		this.translate();
    },
	
    attachEvents: function() {
        this.listenTo(EventHub, 'report:table', data => {
			var handlebarsTemplate = Handlebars.template(tables_template);
			this.$el.html(handlebarsTemplate(this.trazobj));
			this.$el.find('#tratablecontainer').hide();           
			if (data.kind == 'report') {
				var obj = {
					report: [{
						id: data.ID
					}]
				};
				this.settittle(data.kind, obj);
                Parse.Cloud.run("gettrazreport",{"reportID": data.ID}).then((trazreport) => {
                    this.showtable(trazreport,data.kind);
                },
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
            }
            if (data.kind == 'user') {
                var obj = {
					user: [{
						id: data.ID,
						attributes: {
							username: data.username
						}
					}]
				};
				this.settittle(data.kind, obj);
				Parse.Cloud.run("gettrazuser",{"userID": data.ID}).then((trazuser) => {
                    this.showtable(trazuser,data.kind);
                },
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				}); 
            }
        })    
    },

    createexcel: function(tablename){
		var date1 = new Date();
		var options = { year: 'numeric', month: 'numeric', day: 'numeric' };var options2 = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
		date1 = date1.toLocaleDateString(lang+'-GB',options);
		var uri = 'data:application/vnd.ms-excel;base64,'
		, template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
		, base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
		, format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
		var table = "selectedtable"; 
		if (!table.nodeType) table = document.getElementById("selectedtable")
		var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML }
		var link = document.createElement("a");
		link.download = "Informe para "+this.kind2+" "+this.id+" "+date1+".xls";
		link.href = uri + base64(format(template, ctx));
		link.click();
    }
});
export default traTablesView;